module.exports = __webpack_public_path__ + "img/vs.ff8b50c1.png";